import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'redux';
import theme, { sliceFontStyle } from '../../styles/theme';
import {
  getSliceContent,
  getTiles,
  getSliceRichTextGridSize,
  getSliceTitleAlignment,
  getSliceTextAlignment,
  getSliceTitleFontStyle,
  getSliceFontStyle,
} from '../../selectors';
import get from '../../helpers/get';
import Tile, { tileShape } from './Tile';

const Tiles = ({
  tiles,
  classes,
  gridSize,
  imageSize,
  titleAlignment,
  textAlignment,
  titleFontStyle,
  textFontStyle,
}) => (
  <div className={cn(classes.wrapper, classes[gridSize])}>
    {
      tiles.map((tile, i) => (
        <Tile
          key={i} // eslint-disable-line react/no-array-index-key
          className={classes.tile}
          imageSize={imageSize}
          titleAlignment={titleAlignment}
          textAlignment={textAlignment}
          titleFontStyle={titleFontStyle}
          textFontStyle={textFontStyle}
          {...tile}
        />
      ))
    }
  </div>
);

Tiles.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types -- used in mapStateToProps
  sliceId: PropTypes.number.isRequired,
  tiles: PropTypes.arrayOf(PropTypes.shape(tileShape)).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types -- used in injectSheet
  columns: PropTypes.string,
  gridSize: PropTypes.string,
  imageSize: PropTypes.number,
  titleAlignment: PropTypes.string,
  textAlignment: PropTypes.string,
  titleFontStyle: PropTypes.string,
  textFontStyle: PropTypes.string,
};

Tiles.defaultProps = {
  columns: undefined,
  gridSize: undefined,
  imageSize: undefined,
  textAlignment: 'center',
  titleAlignment: 'center',
  titleFontStyle: sliceFontStyle['Bold (Proxima Nova Bold)'],
  textFontStyle: sliceFontStyle['Body (Proxima Nova Regular)'],
};

const mapStateToProps = (state, { sliceId }) => ({
  tiles: getTiles(state, sliceId),
  imageSize: get(getSliceContent(state, sliceId), ['image_size']),
  columns: get(getSliceContent(state, sliceId), ['number_of_columns']),
  gridSize: getSliceRichTextGridSize(state, sliceId),
  titleAlignment: getSliceTitleAlignment(state, sliceId),
  textAlignment: getSliceTextAlignment(state, sliceId),
  titleFontStyle: sliceFontStyle[getSliceTitleFontStyle(state, sliceId)],
  textFontStyle: sliceFontStyle[getSliceFontStyle(state, sliceId)],
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    wrapper: {
      margin: [0, 'auto', theme.spacing.vertical.md],
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        flex: ({ columns }) => `1 ${100 / parseInt(columns, 10)}%`,
      },
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
    },
    small: {
      maxWidth: 768,
    },
  }),
)(Tiles);
